
export const tagInformationToProps = ({ tagging }, { id }) => {
  const tag = tagging.getIn(['tags', 'entities', 'tags', id])
  return {
    ...tag,
    name: tag.key
  }
}
